import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs';

import { ReportSelectComponent } from '../../../../shared/component/report-select/report-select.component';
import { DestroyableComponent } from '../../../../shared/services/destroyable.component';

import {
  ReportPaginationService,
  ReportPayload
} from '../report-pagination.service';
import { PdfmakeReportService } from '../../../../shared/services/pdfmake-report.service';
import { ApiCallsService } from '../../../../shared/services/api-calls.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as pdfjsLib from 'pdfjs-dist';
import { ToastService } from '../../../../shared/services/toast.service';

(pdfjsLib as any).GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;
@Component({
  selector: 'app-monthly-report',
  imports: [CommonModule, ReportSelectComponent],
  templateUrl: './monthly-billing-report.component.html',
  styleUrl: './monthly-report.component.scss'
})
export class MonthlyBillingReportComponent extends DestroyableComponent implements OnDestroy, OnInit{
  pdfDoc: any;
totalPages = 0;
currentPage = 1;
pdfUrl: any

@ViewChild('pdfCanvas', { static: false })
canvasRef!: ElementRef<HTMLCanvasElement>;
loadPdf(url: string) {
  this.pdfUrl = url;

  pdfjsLib.getDocument(url).promise.then((pdf: any) => {
    this.pdfDoc = pdf;
    this.totalPages = pdf.numPages;

    this.renderPage(1);
  });
}
renderPage(pageNumber: number) {
  this.pdfDoc.getPage(pageNumber).then((page: any) => {
    const viewport = page.getViewport({ scale: 1.5 });

    const canvas = this.canvasRef.nativeElement;
    const context = canvas.getContext('2d');

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    page.render({
      canvasContext: context,
      viewport: viewport
    });
  });
}
prevPage() {
  if (this.currentPage <= 1) return;
  this.currentPage--;
  this.renderPage(this.currentPage);
}

nextPage() {
  if (this.currentPage >= this.totalPages) return;
  this.currentPage++;
  this.renderPage(this.currentPage);
}
pdfDownload() {
  if (!this.currentUrl) return;

  const link = document.createElement('a');
  link.href = this.currentUrl;
  link.download = this.pdfName;
  link.target = '_blank';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
  showtable = false;
  totalCount = 0;
  mode:string|null = localStorage.getItem('mode')
  currentUrl: any;
  pdfName: string;
  constructor(
    private readonly reportService: ReportPaginationService,
    private readonly pdfservice:PdfmakeReportService,
    private readonly apiservice:ApiCallsService,
    private readonly sanitizer: DomSanitizer,
    private readonly toast:ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.reportService.showTable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(v => this.showtable = v);

    this.reportService.totalCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(c => this.totalCount = c);
    this.pdfservice.pdfPreview$.subscribe(res => {

    // cleanup old URL
    if (this.currentUrl) {
      URL.revokeObjectURL(this.currentUrl);
    }

    this.loadPdf(res.url)
    this.currentUrl = res.url
    this.pdfName = res.name;

    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
  });
    
  }
flatString:string =''
date:string =''
  // 🔹 Filter submit
handleFilters(rawPayload: Partial<ReportPayload>) {

  const payload: any = {
    site_id: rawPayload.site_ids ?? '',
    from_location_id: rawPayload.loc_from || (rawPayload as any).loc_idFrom || (rawPayload as any).from_location_id || '',
    to_location_id: rawPayload.loc_to || (rawPayload as any).loc_idTo || (rawPayload as any).to_location_id || '',
    date: rawPayload.date,
  };
  if (rawPayload.loc_id) {
    payload.water_loc_id = rawPayload.loc_id
  }
  this.apiservice.getMonthlyBill(payload).subscribe(res => {

    console.log('📦 API Response:', res);

    // ❌ handle error case
    if (res?.Status === 'Error') {
      this.pdfDoc = null
      console.error('🚫 API Error:', res?.Message);
      this.toast.showToast(res?.Message || 'No Data Found','colored',5000,'danger');
      return; // ⛔ STOP HERE
    }

    // ✅ extract flat numbers
    const flatNos = (res?.Data?.list || [])
      .map((item: any) => item.flat_no)
      .filter(Boolean);

    // convert to comma separated string
    const flatString = flatNos.join(', ');
    this.flatString= flatString
    const [year, month] = payload.date.split('-');

    const formattedDate = new Date(Number(year), Number(month) - 1)
      .toLocaleString('en-IN', { month: 'long', year: 'numeric' });

    this.date = formattedDate;

    // ✅ pass everything to PDF
    this.pdfservice.MakePDF(
      res.Data.list,
      this.mode?.toLowerCase() || '',
    );
  });
}

  // 🔹 Reset
  override ngOnDestroy(): void {
    this.handlereset(false);
  }
  handlereset(show: boolean) {
    if (!show) {
      this.reportService.reset();
    }
  }
}
